import { MapPin, Mail, Phone } from "lucide-react";
import { scrollToSection } from "@/lib/lenis";

const LINKS = [
  { name: "About", target: "#about" },
  { name: "Sectors", target: "#sectors" },
  { name: "Approach", target: "#approach" },
  { name: "Contact", target: "#contact" },
];

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="bg-[#12344E]">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-14 grid md:grid-cols-3 gap-12">
        <div>
          <img src="/logo-white.png" alt="Jamsac Investments Limited" className="h-11 w-auto" />
          <p className="text-sm text-[#9FB6C9] leading-relaxed mt-5 max-w-xs">
            A privately owned investment company, building and managing a
            diversified portfolio of property, businesses and strategic
            investments across New Zealand and Australia.
          </p>
        </div>
        <div>
          <h3 className="text-xs font-bold uppercase tracking-[0.2em] text-white mb-5">Quick Links</h3>
          <nav className="flex flex-col gap-3 items-start">
            {LINKS.map((l) => (
              <button
                key={l.name}
                data-testid={`footer-link-${l.name.toLowerCase()}`}
                onClick={() => scrollToSection(l.target)}
                className="text-sm text-[#9FB6C9] hover:text-white transition-colors duration-300"
              >
                {l.name}
              </button>
            ))}
          </nav>
        </div>
        <div>
          <h3 className="text-xs font-bold uppercase tracking-[0.2em] text-white mb-5">Contact</h3>
          <div className="space-y-3.5 text-sm text-[#9FB6C9]">
            <p className="flex items-start gap-2.5">
              <MapPin size={15} className="shrink-0 mt-0.5 text-[#1F6191]" />
              526 Victoria Street, Hamilton 3204
            </p>
            <p className="flex items-center gap-2.5">
              <Mail size={15} className="shrink-0 text-[#1F6191]" />
              info@jamsacinvestments.com
            </p>
            <p className="flex items-center gap-2.5">
              <Phone size={15} className="shrink-0 text-[#1F6191]" />
              +64 274 468 365
            </p>
          </div>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-6 lg:px-10 py-6">
          <p className="text-xs text-[#9FB6C9]/70">
            © 2025 Jamsac Investments Limited. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}
